'use client';

import React from 'react';

const NewsletterPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg, #0a1628 0%, #0d1f3c 60%, #0a1628 100%)',
        padding: '3rem 1.25rem 5rem',
      }}
    >
      <div style={{ maxWidth: 900, margin: '0 auto' }}>

        {/* Page header */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <p style={{ fontSize: '0.8rem', fontWeight: 600, letterSpacing: '0.18em', color: '#f4c430', textTransform: 'uppercase', marginBottom: '0.5rem' }}>
            Stellar Scholar
          </p>
          <h1
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(2rem, 5vw, 3rem)',
              fontWeight: 700,
              color: '#ffffff',
              margin: '0 0 0.5rem',
              lineHeight: 1.15,
            }}
          >
            Newsletter
          </h1>
          <div style={{ width: 60, height: 3, background: '#f4c430', borderRadius: 2, margin: '0.75rem auto 1rem' }} />
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.85rem' }}>
            Stay up to date with the latest from Stellar Scholar
          </p>
        </div>

        {/* Newsletter images */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          <img
            src="/assets/images/Summer_2026-1-1784683322483.png"
            alt="Stellar Scholar Summer 2026 Newsletter — Page 1"
            style={{ width: '100%', borderRadius: 12, display: 'block' }}
          />
          <img
            src="/assets/images/Summer_2026-2-1784683322729.png"
            alt="Stellar Scholar Summer 2026 Newsletter — Page 2"
            style={{ width: '100%', borderRadius: 12, display: 'block' }}
          />
        </div>

      </div>
    </div>
  );
};

export default NewsletterPage;